import axios from "axios";
import { supabase } from "../supabaseClient";

// FarVision node API base; set REACT_APP_FARVISION_NODE_API_URL in .env (missing = production)
const FARVISION_NODE_API_URL = (process.env.REACT_APP_FARVISION_NODE_API_URL || "https://labour.vjerp.com:4423").replace(/\/+$/, "");

// Bank verification goes through the sales backend so the Surepass token stays
// server-side; it used to be read here from REACT_APP_SUREPASS_TOKEN, which
// shipped in the JS bundle. See routes/surepass.js in SALES-APP-BACKEND-NODE-API.
const SUREPASS_BASE = `${String(process.env.REACT_APP_PAYMENT_LINK_URL || "").replace(/\/+$/, "")}/api/surepass`;

async function getAllCancellationBankDetails(from, to, searchValue) {
  // const limit = 10;
  // const fromCount = nextRange?.from;
  // const toCount = nextRange?.to;
  let query = supabase
    .from("RefundForm")
    .select("*,RefundFormUpdateLedgerResp!left(*)", { count: "exact" })
    .order("last_updated_at", {
      ascending: false,
    })
    .range(from, to);

  if (searchValue && searchValue !== "") {
    query = query.or(
      `panNumber.ilike.%${searchValue}%`,
      `customerBankDetails.accHolderName.ilike.%${searchValue}%`
    );
  }
  const { data, count, error } = await query;
  if (data) return { data, count };
  else throw error;
}

async function updateBankRecordStatus(status, panNumber) {
  const { data, error } = await supabase
    .from("RefundForm")
    .update({ status: status })
    .eq("panNumber", panNumber);
  if (data) return { data };
  else throw error;
}

async function BankFormSubmit(obj) {
  const { data, error, count } = await supabase.from("RefundForm").insert(obj);
  if (data) return { data };
  else throw error;
}

async function inserRefundFormLedger(obj) {
  const { data, error, count } = await supabase
    .from("RefundFormUpdateLedgerResp")
    .insert(obj);
  if (data) return { data };
  else throw error;
}

async function BankFormUpdate(obj, panNumber) {
  const { data, error, count } = await supabase
    .from("RefundForm")
    .update(obj)
    .eq("panNumber", panNumber);
  if (data) return { data };
  else throw error;
}

async function getBankDetailStatus(panNumber) {
  const { data, error, count } = await supabase
    .from("RefundForm")
    .select("*")
    .eq("panNumber", panNumber);
  if (data) return { data };
  else throw error;
}

async function UpdateLedgerData(obj) {
  const response = await axios.post(
    `${FARVISION_NODE_API_URL}/bankTransactions/checkUpdateLedger`,
    { ...obj }
  );

  return response;
}

async function getCustomerLedgerId(bookingId) {
  const { data, error, count } = await supabase
    .from("AllotmentPayment")
    .select("*")
    // .select("customerLedgerRes")
    .eq("bookingId", bookingId);
  if (data) return { data };
  else throw error;
}

async function getBankAccDetails(bankObj) {
  // ifsc_details is deliberately not sent — the backend forwards it only when a
  // caller provides it, so this keeps the same response shape as before.
  // parseInt is left as-is to preserve existing behaviour; note it strips any
  // leading zeros from the account number.
  const response = await axios.post(`${SUREPASS_BASE}/bank-verification`, {
    id_number: parseInt(bankObj.accountNo),
    ifsc: bankObj.ifscCode,
  });

  return response;
}

async function getPanAndBankConfirmationDetails(panNo) {
  const response = await axios.post(
    // "https://labour.vjerp.com:4423/bankTransactions/getCustomerDetails",
    `${FARVISION_NODE_API_URL}/bankTransactions/getCustomer`,
    { pan: panNo.toUpperCase() }
  );

  return response;
}

async function getPanAndBankBookingDetails(panNo) {
  const response = await axios.post(
    `${FARVISION_NODE_API_URL}/bankTransactions/getCustomerDetails`,
    { pan: panNo.toUpperCase() }
  );

  return response;
}

async function getBankDetailsFromServer() {
  const { data, error, count } = await supabase
    .from("BankDetails")
    .select("*")
    .order("last_updated_at", {
      ascending: false,
    })
  if (data) return { data };
  else throw error;
}

async function insertBankDetails(obj) {
  const { data, error, count } = await supabase
    .from("BankDetails")
    .insert({ ...obj, last_updated_at: (new Date()).getTime() });
  if (data) return { data };
  else throw error;
}

async function updateBankDetails(obj, bankId) {
  const { data, error, count } = await supabase
    .from("BankDetails")
    .update(obj)
    .eq("bankId", bankId);
  if (data) return { data };
  else throw error;
}

async function updateParkingDetails(obj, parkingTypeId) {
  const { data, error, count } = await supabase
    .from("ParkingTypes")
    .update(obj)
    .eq("parkingTypeId", parkingTypeId);
  if (data) return { data };
  else throw error;
}

async function getParkingDetailsFromServer(from, to) {
  const { data, error, count } = await supabase
    .from("ParkingTypes")
    .select("*")
    .order("last_updated_at", {
      ascending: false,
    })
    .range(from, to)
  if (data) return { data };
  else throw error;
}


async function insertParkingDetails(obj) {
  const { data, error, count } = await supabase
    .from("ParkingTypes")
    .insert(obj);
  if (data) return { data };
  else throw error;
}

async function getParkingDetails(parkingType) {
  const { data, error, count } = await supabase
    .from("ParkingTypes")
    .select("*")
    .match({ parkingType: parkingType });
  if (data) return { data };
  else throw error;
}



async function insertNBFCDetails(obj) {
  const { data, error, count } = await supabase
    .from("NBFCDetails")
    .insert(obj)
    .select("*")
  if (data) return { data };
  else throw error;
}

async function getAllNbfcDetails() {
  const { data, error, count } = await supabase
    .from("NBFCDetails")
    .select("*")
    .order("last_updated_at", {
      ascending: false,
    })
  if (data) return { data };
  else throw error;
}

async function updateNbfcDetails(obj, nbfcId) {
  const { data, error, count } = await supabase
    .from("NBFCDetails")
    .update(obj)
    .eq("nbfcId", nbfcId);
  if (data) return { data };
  else throw error;
}

async function deleteBankFromServer(bankId) {
  const { data, error } = await supabase.from("BankDetails").delete().eq("bankId", bankId).select("*");
  if (data) return { data };
  else throw error;
}

async function getHoldDetails(HoldType) {
  const { data, error, count } = await supabase
    .from("HoldTypes")
    .select("*")
    .match({ HoldType: HoldType });
  if (data) return { data };
  else throw error;
}
async function getHoldDetailsFromServer(from, to) {
  const { data, error, count } = await supabase
    .from("HoldTypes")
    .select("*")
    .order("last_update_at", {
      ascending: false,
    })
    .range(from, to)
  if (data) return { data };
  else throw error;
}

async function insertHoldDetails(obj) {
  const { data, error, count } = await supabase
    .from("HoldTypes")
    .insert(obj);
  if (data) return { data };
  else throw error;
}

async function updateHoldDetails(obj, HoldTypeId) {
  const { data, error, count } = await supabase
    .from("HoldTypes")
    .update(obj)
    .eq("HoldTypeId", HoldTypeId);
  if (data) return { data };
  else throw error;
}

async function getHoldTypes(){
  const {data,error}=await supabase.from("HoldTypes").select("HoldType");
  if(data) return {data};
  else throw error;
}
export {
  BankFormSubmit,
  getBankAccDetails,
  getPanAndBankConfirmationDetails,
  getBankDetailStatus,
  BankFormUpdate,
  getAllCancellationBankDetails,
  updateBankRecordStatus,
  getPanAndBankBookingDetails,
  UpdateLedgerData,
  getCustomerLedgerId,
  inserRefundFormLedger,
  getBankDetailsFromServer,
  insertBankDetails,
  updateBankDetails,
  insertNBFCDetails,
  getAllNbfcDetails,
  updateNbfcDetails,
  deleteBankFromServer,
  insertParkingDetails,
  updateParkingDetails,
  getParkingDetailsFromServer,
  getParkingDetails,
  getHoldDetails,
  getHoldDetailsFromServer,
  insertHoldDetails,
  updateHoldDetails,
  getHoldTypes
};
